import React from "react";
import { Link } from "react-router-dom";

const FinanceTabs = ({ tabs, match }) => {
  return (
    <div className="main-body-tab-area">
      <ul>
        {tabs &&
          tabs.map((tab, i) => (
            <Link key={i} to={tab.path}>
              <li className={tab.path == match.url ? "active" : ""}>
                {tab.name}
              </li>
            </Link>
          ))}
      </ul>
    </div>
  );
};

export default FinanceTabs;
